import React, { useEffect } from "react";

const AdComponent = ({
  slot,
  format = "auto",
  fullWidthResponsive = "true",
}) => {
  useEffect(() => {
    const scriptId = "adsbygoogle-init";

    // Inject AdSense script if not already present
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      script.async = true;
      script.setAttribute("data-ad-client", "ca-pub-3683864409644891");
      document.head.appendChild(script);
    }

    // Try to load the ad once script is ready
    const interval = setInterval(() => {
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        try {
          window.adsbygoogle.push({});
        } catch (e) {
          console.error("Adsense push error:", e);
        }
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-3683864409644891"
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={fullWidthResponsive}
    ></ins>
  );
};

export default AdComponent;